document.addEventListener('DOMContentLoaded', function () {
  const menuToggles = document.querySelectorAll('summary.menu-drawer__menu-item');

  menuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const parent = toggle.closest('details');
      if (parent) {
        parent.open = !parent.open;
      }
    });
  });
});
